import { cva } from 'cva';
import React from 'react';
import { CgSpinner } from 'react-icons/cg';

const spinner = cva('spinner', {
  variants: {
    size: {
      xs: 'w-4 h-4',
      sm: 'w-8 h-8',
      md: 'w-12 h-12',
      lg: 'w-16 h-16',
    },
    color: {
      primary: 'text-primary',
      secondary: 'text-secondary',
      disabled: 'text-text-disabled',
    },

    defaultVariants: {
      size: 'sm',
      color: 'primary',
    },
  },
});

function Spinner(props) {
  const { className, size = 'sm', color = 'primary' } = props;
  return (
    <CgSpinner
      className={spinner({
        size,
        color,
        className: `animate-spin ${className}`,
      })}
    />
  );
}

export default Spinner;
